import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import type { Tenant } from '@/types/auth'

interface UpdateTenantData {
  id: string
  name: string
  slug: string
  domain?: string | null
  logoUrl?: string | null
  status: Tenant['status']
}

export function useUpdateTenant() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: UpdateTenantData): Promise<Tenant> => {
      const { data: tenant, error } = await supabase
        .from('tenants')
        .update({
          name: data.name,
          slug: data.slug,
          domain: data.domain || null,
          logo_url: data.logoUrl || null,
          status: data.status,
        })
        .eq('id', data.id)
        .select()
        .single()

      if (error) {
        if (error.code === '23505') {
          if (error.message?.includes('slug')) {
            throw new Error('Este identificador já está em uso')
          }
        }
        throw new Error(`Erro ao atualizar empresa: ${error.message}`)
      }

      return tenant as Tenant
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tenants'] })
    },
  })
}
